// Supersede-Banner: warnt, wenn zur selben Bestellung (EBELN) bereits eine JUENGERE Auftrags-
// bestaetigung eingegangen ist (doc.newerAb, s. BE-1 GET /documents/:id-Erweiterung). Eigene
// Datei, damit AbDocumentDetail.js unter der 500-LOC-Regel bleibt (Bauplan "Feature => eigene Datei").
// onOpenDocument ist OPTIONAL (Absprache Welle 1/2): ohne Prop wird nur der Hinweistext gezeigt,
// KEIN toter Button (RULES: kein href="#"/leerer Handler).

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, SectionTitle, btnGhost, fmtDate } from '../ui';

const AbSupersedeBanner = ({ isDarkMode, t, newerAb, onOpenDocument }) => {
  if (!newerAb) return null;
  return (
    <Card isDarkMode={isDarkMode} className={isDarkMode ? 'border-amber-400/30' : 'border-amber-200'}>
      <SectionTitle isDarkMode={isDarkMode}>
        <span className={`flex items-center gap-2 ${isDarkMode ? 'text-amber-300' : 'text-amber-600'}`}>
          <AlertTriangle className="w-4 h-4" />{t('abPdf.supersedeTitle')}
        </span>
      </SectionTitle>
      <p className={`text-sm ${isDarkMode ? 'text-white/70' : 'text-slate-600'}`}>
        {t('abPdf.supersedeMsg', { fileName: newerAb.fileName || '—', date: fmtDate(newerAb.createdAt) })}
      </p>
      {typeof onOpenDocument === 'function' && (
        <button type="button" className={`${btnGhost(isDarkMode)} mt-3`} onClick={() => onOpenDocument(newerAb.id)}>
          {t('abPdf.supersedeOpen')}
        </button>
      )}
    </Card>
  );
};

export default AbSupersedeBanner;
